/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const AddressProps = PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip_code: PropTypes.string,
});

export const AddressValidatorProps = PropTypes.shape({
    address1: PropTypes.func,
    address2: PropTypes.func,
    city: PropTypes.func,
    state: PropTypes.func,
    zip_code: PropTypes.func,
});

export const AddressValidatorDefaults = {
    address1: () => false,
    address2: () => false,
    city: () => false,
    state: () => false,
    zip_code: () => false,
};

export const AddressDefaults = {
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip_code: '',
};
